<template>
  <div class="yhc-component YhcSelect" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>
    <div class="content">
      <el-select
        class="el-component-item"
        :disabled="onlyRead"
        :filterable="filterable"
        :allowCreate="allowCreate"
        :clearable="clearable"
        :multiple="multiple"
        :default-first-option="defaultFirstOption"
        @change="$_change"
        v-model="result"
        :placeholder="placeholder"
      >
        <el-option
          v-for="item in labelSelectOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <PrivateEndLabel
        v-if="endLabel"
        :isBtnEndLabel="isBtnEndLabel"
        :endLabelType="endLabelType"
        :endLabelStyle="endLabelStyle"
        :endLabel="endLabel"
        @tapEndLabel="$_tapEndLabel"
      ></PrivateEndLabel>
    </div>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';
import methodsMixin3 from './componentsData/methodsMixin3';
import watchMixin from './componentsData/watchMixin';
import mountedMixin from './componentsData/mountedMixin';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

let identifierName = 'YhcSelect';

export default {
  name: identifierName,

  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin, methodsMixin, methodsMixin3, watchMixin, mountedMixin],

  data() {
    return {
      result: this.value,
    };
  },

  props: {
    value: {
      type: [String, Boolean, Number, Array],
    },
    onlyReadShowData: {
      type: [Number, String],
    },
    labelSelectOptions: {
      type: Array,
      required: true,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
    defaultFirstOption: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },

  computed: {},
  watch: {},
  methods: {},
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcSelect {
  @include labelCommon();
}
</style>
